import type { PdfComponent } from '../../../TermsAndConditionsRender/components/typed';

export const SECTION2_2: PdfComponent = {
  type: 'section',
  id: 's3s2_2',
  title: '2.2 in-Store (Customer Present) Applications',
  content: [
    {
      type: 'altText',
      id: 's3s2_2heading',
      content: ['In addition to the above:'],
      boldFirst: false,
    },
    {
      type: 'bulletList',
      id: 's3s2_2bullets',
      bulletType: 'alpha',
      content: [
        {
          copy: 'At the outset, Customers must be given the Pre-Contract Information and a sample Credit Agreement.',
        },
        {
          copy: 'Customers must be informed how their personal data will be processed, and consent for a credit search must be obtained before proceeding.',
        },
        {
          copy: 'Customers must be allowed to withdraw consent easily.',
        },
        {
          copy: 'A verbal explanation of the key terms and conditions must be given.',
        },
        {
          copy: 'Customers must be informed they are required to pay a deposit via credit or debit card if the application is accepted, and goods/services must be delivered to the address on the Credit Agreement or provided at a Permitted Location.',
        },
        {
          copy: 'Customers must be given time to read and review all documentation and ask questions.',
        },
        {
          copy: 'The Credit Agreement must be signed in-store, and a signed copy provided to the Customer immediately.',
        },
        {
          copy: 'Deposits must be taken by Chip and PIN using a card matching the Customer’s name on the agreement. If not, ID must be collected and verified (passport or photocard driving licence).',
        },
        {
          copy: 'Credit applications must not proceed if there are doubts about affordability or mental capacity.',
        },
        {
          copy: 'Unique login credentials for credit application systems must not be shared. Access must be revoked immediately upon staff departure or status change.',
        },
      ],
    },
    {
      type: 'altText',
      id: 's3s2_2footer',
      content: [
        'Only Approved Salespersons may present finance options to Customers.',
      ],
      boldFirst: false,
    },
  ],
};
